import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { GalleryIcon } from "../../../../../assets/images/icons/GalleryIcon";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton";
import BriaTooltip from "../../../../../components/common/BriaTooltip/BriaTooltip";
import { APPS } from "../../../../../constants/AppsConstants";
import useSecureNavigate from "../../../../../hooks/useSecureNavigate";
import { useAppStore } from "../../../../../hooks/useStores";
import { PlaygroundImage } from "../../../../../models/playground";
import styles from "../PlaygroundImageOverlay.module.scss";

type Props = { image: PlaygroundImage };

const ImageOverlayEditorButton = ({ image }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.imageOverlay" });
	const { playgroundStore } = useAppStore();
	const navigate = useSecureNavigate();
	const openAiEditor = async () => {
		playgroundStore.onAiEditorButtonClick(image, navigate);
	};
	const showAsButton =
		playgroundStore.selectedConfig !== APPS.TEXT_TO_IMAGE && image.type !== APPS.TG_IMAGE_GENERATION;

	const TextButton = (
		<BriaTooltip className={styles.tooltip} title={t("customizeImage")}>
			<BriaButton
				buttonType="tertiaryMedium"
				onClick={openAiEditor}
				className={clsx(styles.aiEditorButton, {
					["iconHover"]: true,
				})}
			>
				{t("aiEditor")}
			</BriaButton>
		</BriaTooltip>
	);

	const IconButton = (
		<BriaTooltip title={t("aiEditing")}>
			<BriaButton
				buttonType="tertiaryMedium"
				className={clsx(styles.aiEditorIcon, {
					["iconHover"]: true,
				})}
				onClick={openAiEditor}
			>
				<GalleryIcon />
			</BriaButton>
		</BriaTooltip>
	);

	return showAsButton ? TextButton : IconButton;
};

export default observer(ImageOverlayEditorButton);
